import Loader from "./loader";

// const Loader = () => {
//   return (
//     <div
//       className="h-8 w-8 animate-[loaderPage_1.5s_infinite_cubic-bezier(0.3,1,0,1)]"
//       style={{
//         color: "#09864a",
//         background: `
//           linear-gradient(currentColor 0 0),
//           linear-gradient(currentColor 0 0),
//           linear-gradient(currentColor 0 0),
//           linear-gradient(currentColor 0 0)
//         `,
//         backgroundSize: "21px 21px",
//         backgroundRepeat: "no-repeat",
//       }}
//     ></div>
//   );
// };


export default function PageLoader() {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-5 bg-[#F5F3f0] dark:bg-[#15161D]">
      <Loader />
      <h2 className="text-sm text-semiDarkGrey dark:text-secondaryGrey">
        Loading page...
      </h2>
    </div>
  );
}
